/**
 * 延迟一段时间再进入下一个步骤
 * @param ms 延迟的毫秒数
 * @returns {Promise<unknown>}
 */
export default function delay({ms}) {
    return new Promise(resolve=>{
        setTimeout(resolve, ms);
    });
}
